import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";

export const PageParametresUsager = ({ user, onUpdateUser }) => {
  const token = user?.token;

  /* ── Infos personnelles ── */
  const [nom, setNom]                   = useState("");
  const [prenom, setPrenom]             = useState("");
  const [telephone, setTelephone]       = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [adresse, setAdresse]           = useState("");
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [savingNom, setSavingNom]       = useState(false);
  const [nomMsg, setNomMsg]             = useState(null);

  /* ── Mot de passe ── */
  const [currentPwd, setCurrentPwd]   = useState("");
  const [newPwd, setNewPwd]           = useState("");
  const [showPwd, setShowPwd]         = useState(false);
  const [savingPwd, setSavingPwd]     = useState(false);
  const [pwdMsg, setPwdMsg]           = useState(null);

  /* ── Chargement du profil ── */
  useEffect(() => {
    if (!token) { setLoadingProfile(false); return; }
    fetch(`${API_BASE}/usager/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : {})
      .then(d => {
        setNom(d.nom || "");
        setPrenom(d.prenom || "");
        setTelephone(d.telephone || "");
        setDateNaissance(d.date_naissance || "");
        setAdresse(d.adresse || "");
      })
      .catch(() => {})
      .finally(() => setLoadingProfile(false));
  }, [token]);

  /* ── Sauvegarde infos ── */
  const handleSaveNom = async (e) => {
    e.preventDefault();
    setSavingNom(true);
    setNomMsg(null);
    try {
      const res = await fetch(`${API_BASE}/usager/me`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ nom, prenom, telephone, adresse }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setNomMsg({ type: "ok", text: data.msg || "Profil mis à jour." });
        onUpdateUser?.({ nom_complet: data.nom_complet });
      } else {
        setNomMsg({ type: "err", text: data.msg || "Erreur lors de la mise à jour." });
      }
    } catch {
      setNomMsg({ type: "err", text: "Impossible de contacter le serveur." });
    } finally {
      setSavingNom(false);
    }
  };

  /* ── Changement de mot de passe ── */
  const handleSavePwd = async (e) => {
    e.preventDefault();
    if (!currentPwd || !newPwd) {
      setPwdMsg({ type: "err", text: "Veuillez remplir tous les champs." });
      return;
    }
    if (newPwd.length < 8) {
      setPwdMsg({ type: "err", text: "Le nouveau mot de passe doit contenir au moins 8 caractères." });
      return;
    }
    setSavingPwd(true);
    setPwdMsg(null);
    try {
      const res = await fetch(`${API_BASE}/usager/password`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ current_password: currentPwd, new_password: newPwd }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setPwdMsg({ type: "ok", text: data.msg || "Mot de passe mis à jour." });
        setCurrentPwd("");
        setNewPwd("");
      } else {
        setPwdMsg({ type: "err", text: data.msg || "Erreur lors du changement." });
      }
    } catch {
      setPwdMsg({ type: "err", text: "Impossible de contacter le serveur." });
    } finally {
      setSavingPwd(false);
    }
  };

  if (loadingProfile) {
    return <div className="uDashLoading" style={{ padding: "60px 0" }}>Chargement…</div>;
  }

  return (
    <div className="uParams">

      {/* ── Informations personnelles ── */}
      <div className="uParamsSection">
        <div className="uParamsSectionHeader">
          <div className="uParamsSectionTitle">Informations personnelles</div>
          <div className="uParamsSectionSub">Modifiez vos coordonnées personnelles.</div>
        </div>

        <form className="uParamsForm" onSubmit={handleSaveNom}>

          {/* Email lecture seule */}
          <div className="uParamsField">
            <label className="uParamsLabel">Adresse email</label>
            <input
              className="uParamsInput uParamsInputDisabled"
              type="email"
              value={user?.email || ""}
              readOnly
              disabled
            />
            <span className="uParamsHint">L'email ne peut pas être modifié.</span>
          </div>

          {/* Nom + Prénom sur la même ligne */}
          <div className="uParamsRow">
            <div className="uParamsField">
              <label className="uParamsLabel">Nom <span className="uParamsRequired">*</span></label>
              <input
                className="uParamsInput"
                type="text"
                placeholder="Dupont"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                required
              />
            </div>
            <div className="uParamsField">
              <label className="uParamsLabel">Prénom</label>
              <input
                className="uParamsInput"
                type="text"
                placeholder="Jean"
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
              />
            </div>
          </div>

          {/* Téléphone */}
          <div className="uParamsField">
            <label className="uParamsLabel">Téléphone</label>
            <input
              className="uParamsInput"
              type="tel"
              placeholder="06 12 34 56 78"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
            />
          </div>

          {/* Date de naissance */}
          <div className="uParamsField">
            <label className="uParamsLabel">Date de naissance</label>
            <input
              className="uParamsInput uParamsInputDisabled"
              type="date"
              value={dateNaissance}
              readOnly
              disabled
            />
            <span className="uParamsHint">La date de naissance ne peut pas être modifiée.</span>
          </div>

          {/* Adresse */}
          <div className="uParamsField">
            <label className="uParamsLabel">Adresse</label>
            <input
              className="uParamsInput"
              type="text"
              placeholder="10 rue de la Paix, 75001 Paris"
              value={adresse}
              onChange={(e) => setAdresse(e.target.value)}
            />
          </div>

          {nomMsg && (
            <div className={`uParamsMsg ${nomMsg.type === "ok" ? "uParamsMsgOk" : "uParamsMsgErr"}`}>
              {nomMsg.text}
            </div>
          )}

          <button
            type="submit"
            className="uParamsBtn"
            disabled={savingNom || !nom.trim()}
          >
            {savingNom ? "Enregistrement…" : "Enregistrer les modifications"}
          </button>
        </form>
      </div>

      {/* ── Mot de passe ── */}
      <div className="uParamsSection">
        <div className="uParamsSectionHeader">
          <div className="uParamsSectionTitle">Mot de passe</div>
          <div className="uParamsSectionSub">Choisissez un mot de passe d'au moins 8 caractères.</div>
        </div>

        <form className="uParamsForm" onSubmit={handleSavePwd}>
          <div className="uParamsField">
            <label className="uParamsLabel">Mot de passe actuel</label>
            <div className="uParamsInputWrap">
              <input
                className="uParamsInput"
                type={showPwd ? "text" : "password"}
                placeholder="••••••••"
                value={currentPwd}
                onChange={(e) => setCurrentPwd(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="uParamsField">
            <label className="uParamsLabel">Nouveau mot de passe</label>
            <div className="uParamsInputWrap">
              <input
                className="uParamsInput"
                type={showPwd ? "text" : "password"}
                placeholder="••••••••"
                value={newPwd}
                onChange={(e) => setNewPwd(e.target.value)}
                required
              />
              <button
                type="button"
                className="uParamsEye"
                onClick={() => setShowPwd(v => !v)}
                aria-label={showPwd ? "Masquer" : "Afficher"}
              >
                {showPwd ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {pwdMsg && (
            <div className={`uParamsMsg ${pwdMsg.type === "ok" ? "uParamsMsgOk" : "uParamsMsgErr"}`}>
              {pwdMsg.text}
            </div>
          )}

          <button
            type="submit"
            className="uParamsBtn"
            disabled={savingPwd}
          >
            {savingPwd ? "Enregistrement…" : "Changer le mot de passe"}
          </button>
        </form>
      </div>
    </div>
  );
};
